import { render, staticRenderFns } from "./biddinglist.vue?vue&type=template&id=6af82399&scoped=true&"
import script from "./biddinglist.vue?vue&type=script&lang=js&"
export * from "./biddinglist.vue?vue&type=script&lang=js&"
import style0 from "./biddinglist.vue?vue&type=style&index=0&id=6af82399&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af82399",
  null
  
)

export default component.exports